import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "searvices-area pt-100 pb-75" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "d-flex gap-3 flex-wrap justify-content-center justify-content-lg-between" }
const _hoisted_4 = { class: "hover-style1" }
const _hoisted_5 = { class: "hover-style2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "section-title text-center m-auto",
        "data-aos": "fade-up",
        "data-aos-duration": "1000",
        "data-aos-delay": "100"
      }, [
        _createElementVNode("span", { class: "top-title" }, "خدماتنا وميزاتنا"),
        _createElementVNode("h2", null, "اكتشف الباقات والخدمات التي نقدمها لك")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (service) => {
          return (_openBlock(), _createBlock(_component_RouterLink, {
            key: service.id,
            to: "/services-details",
            class: "searvices-single-item",
            "data-aos": "fade-up",
            "data-aos-duration": "1000",
            "data-aos-delay": service.dataDelay
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("i", {
                    class: _normalizeClass(service.icon)
                  }, null, 2)
                ])
              ]),
              _createElementVNode("h3", null, _toDisplayString(service.name), 1)
            ]),
            _: 2
          }, 1032, ["data-aos-delay"]))
        }), 128))
      ])
    ])
  ]))
}